<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<router-link :to="{ path: $routerHistory.previous().path }"
						style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{tn('notiTitle')}}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						{{'詳細'}}
					</v-col>
				</v-row>
			</v-col>
		</v-col>
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10" align="left">
				<v-col class="ma-0 pa-0" align="left" id="header_text">
					{{notificationData.title}}
				</v-col>
				<v-row class="pa-0 pt-5 pb-3" cols="auto" id="main_content_maxwidthset">
					<v-col class="ma-0 pa-0" align="left" style="font-size:0.9rem;">
						{{date}}
					</v-col>
					<!-- <v-col class="mr-2 pa-0" cols="10">
						21:30
					</v-col> -->
				</v-row>
				<v-divider class="ma-0 pa-0 mt-8 mb-6" id="header_divider"></v-divider>
				<v-col class="ma-0 pa-0 newline-format" align="left">
					{{notificationData.description}}
				</v-col>		
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		notificationData: {},
		date: '',
	}),
	created() {
		this.notificationData = this.$store.getters.getNotificationDetail;
    let updateDate = new Date(`${this.notificationData.updatedAt.substring(0,4)}-${this.notificationData.updatedAt.substring(5,7)}-${this.notificationData.updatedAt.substring(8,10)}`)
		this.date = this.getFormatDate(updateDate, 'jap');
		console.log(this.notificationData);
	},
	methods: {
		tn(t) {
      return this.$t("lang.notification." + t);
    },
	}
}
</script>

<style lang="scss" scoped>
#header_text {
  font-size: 1.5rem;
  text-align: left;
}
#header_divider {
	border: 1px solid rgb(141, 141, 141);
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
	color: white;
}
.newline-format {
	white-space: pre-line;
}
</style>